import progress from './progress';
import status from './status';
import prescription from './prescription';
import PatientOverviewMedication from 'dashboard/templates/views/Patient/Medication/PatientOverviewMedication';
import {redirectIfBehaviourModulesAreNotEnabled} from "../../../../../hooks/enabled-module-guard";

/**
 * Medication adherence routes
 * @name router.Medication
 */

const navigationSteps = {
  nextDiscussionStep: {
    PatientRecordMedicationStatus: 'PatientRecordMedicationPrescription',
    PatientRecordMedicationProgress: 'PatientRecordMedicationPrescription',
    PatientRecordMedicationPrescription: 'PatientRecordProgress',
  },
  prevDiscussionStep: {
    PatientRecordMedicationStatus: 'PatientRecordProgress',
    PatientRecordMedicationProgress: 'PatientRecordProgress',
    PatientRecordMedicationPrescription: 'PatientRecordMedicationProgress',
  }
}

export default {
  path: 'medication',
  component: PatientOverviewMedication,
  name: 'PatientRecordMedicaton',
  props: navigationSteps,
  redirect: { name: 'PatientRecordMedicationProgress' },
  meta: {
    // title: 'Patient Record Medication',
    title: t => `${t('patient.patientRecord')} - ${t('screens.medicationAdherenceScreen', 'app_mobile')}`,
    loggedInOnly: true,
  },
  children: [
    progress,
    status,
    prescription,
  ],
  async beforeEnter(to, from, next) {
    // If user was redirected from page because medication adherence is not enabled, don't do anything.
    if (await redirectIfBehaviourModulesAreNotEnabled(["MEDICATIONS"], to, next)){
      return
    }

    next();
  },
};
